import React, { useEffect, useRef, useState } from "react";
import closeIcon from "../../assets/images/close-icon.png";
import styles from "./index.module.scss";
import viewMore from "../../assets/images/viewMore.svg";
import directions from "../../assets/images/directions.svg";
import backBtn from "../../assets/images/backBtn.png";
import share from "../../assets/images/share.svg";
import close from "../../assets/images/clsoe.svg";
import copy from "../../assets/images/copy.png";
import whatsapp from "../../assets/images/whatsapp.png";
import fb from "../../assets/images/fb.png";
import linkedin from "../../assets/images/linkedin.png";
import QRCode from "qrcode";
import { CafeList } from "./Foodmap";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import ImageCarousel from "./ImageCarousel";

const searchTabs = [
    {
        name: "Registration",
        id: 6,
        type: "home",
    },
    {
        name: "Entry/Exit",
        id: 2,
        type: "home",
    },
    {
        name: "Venue Gates",
        id: 7,
        type: "home",
    },
    {
        name: "Cafeteria",
        id: 1,
        type: "home",
    },
    {
        name: "Parking",
        id: 3,
        type: "home",
    },
    {
        name: "Coffee Shops",
        id: 4,
        type: "hall",
    },
    {
        name: "Info Kiosk",
        id: 5,
        type: "hall",
    },
    // {
    //     name: "Center Square",
    //     id: 10,
    //     type: "hall",
    // },
    {
        name: "Service Booth",
        id: 8,
        type: "hall",
    },
    {
        name: "Washroom",
        id: 9,
        type: "hall",
    },
    // {
    //     name: "Innovate Seminar",
    //     id: 11,
    //     type: "hall",
    // },
    // {
    //     name: "Business Enter",
    //     id: 12,
    //     type: "hall",
    // },
    // {
    //     name: "Launch Pad",
    //     id: 13,
    //     type: "hall",
    // },
    // {
    //     name: "Elite Coffee",
    //     id: 14,
    //     type: "hall",
    // },
    // {
    //     name: "Prayer Room",
    //     id: 15,
    //     type: "hall",
    // },
    {
        name: "Water Station",
        id: 16,
        type: "hall",
    },
    // {
    //     name: "Stationary Room",
    //     id: 17,
    //     type: "hall",
    // },
    {
        name: "Charging Station",
        id: 18,
        type: "hall",
    },
    {
        name: "First Aid",
        id: 19,
        type: "hall",
    },
];

const hiddenFilters = [
    6, 1
]

/** Tabs to hide per scene+hall combo. Keys: "scene" or "scene:hallId" */
const HIDDEN_TABS_BY_CONTEXT = {
    "JIO": [18],
    "JIO:hallJWCC": [18],
    "JIO:hallStallCLUB": [18],
};

const JIO_SEARCH_HALLS = {
    hallJWCC: ["PAVILION"],
    hallStallCLUB: ["JASMINE", "LOTUS HALL"],
};

const initalImageUrl =
    "https://storage.googleapis.com/iijs-app.appspot.com/catalog";
var MAXLISTSIZE = 50;

const socialHandles = [
    { name: "whatsapp", src: whatsapp },
    { name: "fb", src: fb },
    { name: "linkedin", src: linkedin },
];

/** Fuse extended-search treats | = ! ' ^ $ etc as operators — strip them from user input */
const sanitizeSearchQuery = (word) =>
    String(word || "")
        .replace(/[\\^$|!=+'"`&]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

const normalizeSearchText = (value) =>
    String(value || "")
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

const Search = ({openJioSwitchModal, handleSceneChange, scene, handleCanvasLoad, list, fuse, productsCategory, subProductsCategory, setCurrentJIOHall }) => {
    const [searchList, setSearchList] = useState([]);
    const [filterType, setFilterType] = useState({ type: "home", id: null });
    const [showSearchIcon, setShowSearchIcon] = useState({
        search: true,
        close: false,
    });
    const [focused, setFocused] = useState(false);
    const [showDetailItem, setShowDetailItem] = useState(false);
    const [shareModal, setShareModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [stallString, setStallString] = useState("");
    const [textInput, setTextInput] = useState("");
    const [lastSelected, setLastSelected] = useState({});
    const [directionMode, setDirectionMode] = useState(false);
    const [foodMenu, setFoodMenu] = useState("");
    const [highlightedTab, setHighlightedTab] = useState("")
    const [navigationView, setNavigationView] = useState(false);


    useEffect(() => {
        setSelectedItem({});
        setShowDetailItem(false);
        setStallString("");
        handleHomeBtnClick()
        setFilterType({ type: "home", id: null });
    }, [scene])

    useEffect(() => {
        if (shareModal) {
            generateQR();
        }
    }, [shareModal]);

    // const _handleCanvasLoad = () =>{
    //     setFilterType({ type: "home", id: null });
    //     handleCanvasLoad();
    // }

    const handleFoodMenu = (id) => {
        setFoodMenu(id);
    };

    const stallHighlightHandler = () => {
        setHighlightedTab("")
    }

    function goToStall(stallData) {
        window.parent.goToStall(true, stallData);
        handleViewMore(true, list[stallData.stallId]);
    }

    function replaceAllWordWithParticularCharacter(
        string,
        strReplace,
        strWith
    ) {
        // See http://stackoverflow.com/a/3561711/556609
        var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        var reg = new RegExp(esc, "ig");
        return string.replace(reg, strWith);
    }

    function goToStall3d(stallData) {
        handleHomeBtnClick()

        let id = stallData.stallId.split("Stall")[1].trim();

        if (id.toLowerCase().includes("jio")) {
            id = replaceAllWordWithParticularCharacter(id, "jio", "JIO");
            id = id.replace(/ /g, "_");
        } else if (id.startsWith("7")) {
            id = id.replace(/ /g, "_").toUpperCase();
        } else {
            // replace with underscore
            id = id.replace(/ /g, "_").toUpperCase();
        }

        id = `Stall${id}`;
        let _stallData = { stallId: id }
        let venue = list[_stallData.stallId].venue?.toUpperCase();
        let isCurrentScene = scene.toUpperCase() == venue;

        console.log(id, " : goToStall3d")
        if (isCurrentScene) {
            goToStall(_stallData)
        } else {
            handleSceneChange(venue, true, goToStall, _stallData,false)
        }
    }

    useEffect(() => {
        window.parent.goToStall3d = goToStall3d;
    }, [scene])

    useEffect(() => {
        window.parent.frontEndLinker = {
            handleCanvasLoad: handleCanvasLoad,
            // closeSearchResult: handleSearchCloseClick,
            // openMediaModal: openMediaModal,
            // closeMediaModal: closeMediaModal,
            hallSwitchPopupJio:openJioSwitchModal,
            viewMore: handleViewMore,
            closeDetailsPop: closeDetailsPop,
            menuOpen: handleFoodMenu,
            deactivateFilterBtn: deactivateFilterBtn,
            updateStartingpointName: updateStartingpointName,
            hallOpen: handleHallOpen,
            hallClose: handleHallClose,
            stallHighlightHandler: stallHighlightHandler,
        };
    }, []);

    const deactivateFilterBtn = () => {
        console.log("dirrs")
    }
    const handleHallClose = () => {
        setHighlightedTab("")
        if (foodMenu) {
            setFoodMenu("")
        }
        setCurrentJIOHall(null)
        setFilterType({ type: "home", id: null });
    };

    const handleHallOpen = (hallId) => {
        setHighlightedTab("")
        if (foodMenu) {
            setFoodMenu("")
        }
        setCurrentJIOHall(hallId)
        setFilterType({ type: "hall", id: hallId });

    };

    const updateStartingpointName = (name) => {
        setTextInput(name);
    };

    const searchWord = (word, filter1 = [], filter2 = []) => {
        const query = sanitizeSearchQuery(word);
        if (!fuse || !query) {
            return [];
        }

        let filterArr1 = filter1.map((v) => ({ product_dealing: v }));
        let filterArr2 = filter2.map((v) => ({ "sub category": v }));
        // Keep spaces so multi-word names match (extended search ANDs tokens)
        let or = [
            "Exhibitor_Name",
            "Search_Name",
            "Exhibitor_StallNo1",
            "Exhibitor_Code",
            "Exhibitor_Section",
            "Exhibitor_Brand_Name",
            "sub category",
            "Any Other Product Category",
            "Any other Sub Product Category",
            "product_dealing",
            "Brands",
        ].map((k) => ({ [k]: query }));

        let a = fuse.search({
            $and: [
                {
                    $or: or,
                },
                ...filterArr1,
                ...filterArr2
            ],
        });

        const activeScene = String(scene || "").toUpperCase();
        a = a.filter(({ item }) =>
            String(item.venue || "").toUpperCase() === activeScene
        );

        const normalizedQuery = normalizeSearchText(query);
        const exactNameMatches = Object.values(list || {})
            .filter((item) => {
                if (String(item.venue || "").toUpperCase() !== activeScene) {
                    return false;
                }
                if (filter1.some((value) => !(item.product_dealing || []).includes(value))) {
                    return false;
                }
                if (filter2.some((value) => !(item["sub category"] || []).includes(value))) {
                    return false;
                }
                return normalizeSearchText(item.Exhibitor_Name).includes(normalizedQuery);
            })
            .map((item) => ({ item }));

        const seen = new Set();
        a = [...exactNameMatches, ...a].filter(({ item }) => {
            const id = item.StallId__1 || item.Exhibitor_Name;
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
        });

        const activeHallId =
            filterType.type === "hall" ? filterType.id : null;
        if (scene === "JIO" && activeHallId && JIO_SEARCH_HALLS[activeHallId]) {
            const allowedHalls = JIO_SEARCH_HALLS[activeHallId];
            a = a.filter(({ item }) =>
                allowedHalls.includes(
                    String(item.Exhibitor_Hall || "").toUpperCase()
                )
            );
        }

        return a;
    };

    function searchThis(pattern) {
        // if (searchReady)
        return searchWord(
            pattern,
            Object.keys(productsCategory).filter((id) => productsCategory[id]),
            Object.keys(subProductsCategory).filter((id) => subProductsCategory[id])
        );
        // else return null;
    }

    function showSearchResults(value, forNav = false) {
        // if (!populatedList.classList.contains("showPList")) {
        //   populatedList.classList.add("showPList");
        // }
        // if (navigationMode) {
        //   populatedList.classList.add("navmodeSelectlist");
        // }

        // var temp = document.getElementById("populatedList");
        // var searchEles = temp.children;

        // for (var i = searchEles.length - 1; i >= 0; i--)
        //   searchEles[i].parentNode.removeChild(searchEles[i]);

        var __searchList = searchThis(value) || [];
        setSearchList(__searchList.slice(0, MAXLISTSIZE));
        // if (searchList.length > 0) {
        //   searchList = searchList.splice(0, MAX_LIST_SIZE);
        //   if (!forNav) {
        //     lastSelected = null;
        //   }
        //   for (var i = 0; i < searchList.length; i++) {
        //     itemClone(i, temp, searchList[i].item, forNav);
        //   }
        // } else {
        //   if (!forNav) {
        //     lastSelected = null;
        //   }
        //   for (var i = 0; i < list.length; i++) {
        //     itemClone(i, temp, list[i], forNav);
        //   }
        // }
    }

    const handleChange = (e) => {
        //   viewMoreBackBtn();
        if (foodMenu) {
            setFoodMenu("")
        }
        if (e.target.value) {
            setShowSearchIcon({
                search: false,
                close: true,
            });
            showSearchResults(e.target.value);
            setTextInput(e.target.value);
        } 
        else {
            setShowSearchIcon({
                search: true,
                close: false,
            });
            clearTextField();
        }
    };
    const homeBtnClick = () => {
        console.log("first");
    };

    const handleViewMore = (e, item) => {
        if (foodMenu) {
            setFoodMenu("")
        }
        if (directionMode) {
            handleExtend(item);
            return;
        }
        setShowDetailItem(true);
        setSelectedItem(item);
        let stallCount = 0;
        const keyValues = ["Exhibitor_StallNo1"];
        let _stallString = "";

        // , "Exhibitor_StallNo2", "Exhibitor_StallNo3", "Exhibitor_StallNo4", "Exhibitor_StallNo5", "Exhibitor_StallNo5"]
        keyValues.forEach((key) => {
            if (item[key]) {
                stallCount++;
                if (stallCount > 1) {
                    _stallString += ", " + item[key];
                } else {
                    _stallString += item[key];
                }
                setStallString(_stallString);
            }
        });
    };

    const handleDirections = (item) => {
        setFocused(true);
        setShowDetailItem(false);
        setLastSelected(item);
        setDirectionMode(true);
        setSearchList([]);
        setTextInput("");
        setSelectedItem({});
    };

    const handleShare = (id) => {
        console.log(id);
    };

    const handleExtend = (item) => {
        if (directionMode) {
            window.parent.nav.navigateBetweenStalls(
                { ...list[item.StallId__1], stallId: item.StallId__1 },
                { ...list[lastSelected.StallId__1], stallId: lastSelected.StallId__1 },
            );
            setNavigationView(true);
            setSearchList([]);
            setTextInput(item.Exhibitor_Name);
            // setFocused(false)
            return;
        }
        setSelectedItem(item);
        if (typeof window.parent.goToStall !== "undefined") {
            item.stallId = item.StallId__1;
            // item.imgURL =
            //     initalImageUrl +
            //     "/" +
            //     item.Exhibitor_Code +
            //     "/" +
            //     item.Catalog_CompanyLogo;
            item.imgURL =
                item.Catalog_CompanyLogo;

            item.stallName = "" + item.Exhibitor_Name;
            window.parent.goToStall(true, item);
        }
    };

    const handleHomeBtnClick = () => {
        setHighlightedTab("")
        setCurrentJIOHall(null)
        if (directionMode) {
            exitDirections();
        } else {
            if (typeof window.parent.goToHome !== "undefined") {
                window.parent.goToHome((res) => {
                    console.log(res, "Resss")
                    // if (tabname) {
                    //     additionalFiltersTabClick(
                    //         DIRECT_KEYS[tabname].CHILDINDEX,
                    //         DIRECT_KEYS[tabname].TABINDEX,
                    //         true
                    //     );
                    // }
                });
            }

            // activateOutsideFilters();
            // if (!additional) {
            //   additionalFiltersTabClick(0);
            // }
            handleBack();
            // handleSearchCloseClick();
            // exitDirections();
            // if (typeof window.parent.highlightTab !== "undefined")
            //     if (!additional) {
            //         window.parent.highlightTab(0, false);
            //     }
        }
    };

    const clearTextField = () => {
        // if (directionMode) {
        //     exitDirections();
        //     return;
        // }
        setTextInput("");
        setShowSearchIcon({
            search: true,
            close: false,
        });
        setSearchList([]);
        closeDetailsPop();
        // Keep current hall filter so Pavilion/Jasmine search scope stays active
    };

    const closeDetailsPop = () => {
        setSelectedItem({});
        setShowDetailItem(false);
        setStallString("");
    };

    const handleBack = () => {
        setHighlightedTab("")
        if (typeof window.parent.goToHome !== "undefined") {
            window.parent.getBackOneLevel((red) => {
                console.log(red, "red")
            });
            // setFilterType({ type: "home", id: null });
        }

        closeDetailsPop();
    };

    const handleModal = () => {
        setShareModal((prev) => !prev);
    };

    const exitDirections = () => {
        try {
            if (window.parent?.nav?.exitNavigation) {
                window.parent.nav.exitNavigation();
            }
        } catch (err) {
            console.error("exitNavigation failed:", err);
        }
        setShowSearchIcon({
            search: true,
            close: false,
        });
        handleBack();
        setDirectionMode(false);
        setFilterType({ type: "home", id: null });
        setTextInput("");
        setFocused(false);
        setNavigationView(false);
    };

    const additionalTabsClick = (e) => {
        updateStartingpointName("");
        setSearchList([]);
        setShowDetailItem(false)
        if (directionMode) {
            exitDirections()
        }
        if (typeof window.parent.highlightTab !== "undefined")
            if (highlightedTab == e) {
                window.parent.highlightTab(e, false);
                setHighlightedTab("")

            } else {
                window.parent.highlightTab(e, true);
                setHighlightedTab(e)

            }

        //   if (stallInput.disabled) {
        //     navigationMode = false;
        //     exitDirections();

        //   lastActiveNumber = e;
        //   lastActiveTab = filtersDiv.children[childIndex];
        //   filtersDiv.children[childIndex].classList.add("activeTab");
        // }
        // handleSearchCloseClick();
        // handleBack();
    };

    const generateQR = () => {
        var canvas = document.getElementById("canvas");

        QRCode.toCanvas(canvas, "sample text", function (error) {
            if (error) console.error(error);
            console.log("success!");
        });
    };

    return (
        <div className={styles.tabContainer}>
            <form
                className={styles.searchForm}
                style={
                    isMobileDevice && navigationView
                        ? { bottom: "10vh" }
                        : focused && isMobileDevice
                            ? directionMode && searchList.length == 0
                                ? { bottom: "40vh" }
                                : { bottom: "50vh", width: "20rem" }
                            : { width: "20rem" }
                }
                onSubmit={(e) => {
                    e.preventDefault();
                }}
            >
                <div className={styles.searchInput}
                    style={
                        directionMode
                            ? {
                                padding: "0 10px 0 45px",
                                boxSizing: "border-box",
                                width: "calc(100% + 48px)",
                            }
                            : {}
                    }>
                    {directionMode && <span>From :</span>}
                    <input
                        value={textInput}
                        type="text"
                        onFocus={() => setFocused(true)}
                        onBlur={() => searchList.length == 0 && setFocused(false)}
                        style={
                            directionMode
                                ? {
                                    width: "80%",
                                    minWidth: "80%"
                                }
                                : {
                                    width: "90%",
                                    minWidth: "90%"
                                }
                        }
                        onChange={handleChange}
                        id="search-bar"
                        name="myInput"
                        autoComplete="off"
                        placeholder="Looking for something?"
                    />
                </div>
                {directionMode && (
                    <>
                        {" "}
                        <img
                            className={styles.blueBack}
                            src="/textures/blueBack.svg"
                            onClick={exitDirections}
                        />
                        <div className={styles.searchInput2}>
                            <span>To :</span>
                            <input
                                value={lastSelected.Exhibitor_Name}
                                type="text"
                                disabled={true}
                            />
                        </div>
                        <img
                            className={styles.searchClose2}
                            src={closeIcon}
                            onClick={()=>{
                                if(directionMode){
                                    exitDirections()
                                }
                                clearTextField()
                            }}
                        />
                    </>
                )}
                {showSearchIcon.search && !directionMode && (
                    <img
                        className={styles.searchIcon}
                        src="https://www.endlessicons.com/wp-content/uploads/2012/12/search-icon.png"
                    />
                )}
                {showSearchIcon.close && !directionMode && (
                    <img
                        className={styles.searchClose}
                        src={closeIcon}
                        onClick={clearTextField}
                    />
                )}
                <div
                    style={
                        isMobileDevice
                            ? searchList.length > 0 || Object.values(selectedItem).length > 0
                                ? directionMode
                                    ? { height: "40vh" }
                                    : { height: "50vh" }
                                : {}
                            : {}
                    }
                    className={styles.populatedList}
                >
                    {!showDetailItem &&
                        searchList.map((_item,index) => {
                            const item = _item.item;
                            return (
                                <React.Fragment key={index}>
                                    <div
                                        onClick={() => handleExtend(item)}
                                        className={styles.listChild}
                                    >
                                        {!showDetailItem && (
                                            <>
                                                <div style={{ width: "20%" }}>
                                                    <img
                                                        style={{ width: "100%", height: "100%" }}
                                                        src="https://www.endlessicons.com/wp-content/uploads/2012/12/search-icon.png"
                                                    />
                                                </div>
                                                <div className={styles.exhibhitorDesc}>
                                                    <div>{item.Exhibitor_Name}</div>
                                                    <div className={styles.exhibitorSubDesc}>
                                                        <div>{"Stall no. " + item.Exhibitor_StallNo1}</div>
                                                        <div>{"Hall " + item.Exhibitor_Hall}</div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            height: selectedItem == item ? "6vh" : "0",
                                                        }}
                                                        className={styles.catalogBrief}
                                                    >
                                                        {item.Catalog_Brief}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {selectedItem == item && (
                                        <div className={styles.btnsWrapper}>
                                            <img
                                                onClick={(e) => handleViewMore(e, item)}
                                                src={viewMore}
                                            />
                                            <img
                                                onClick={() => handleDirections(item)}
                                                src={directions}
                                            />
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    {showDetailItem && selectedItem && (
                        <div className={styles.itemViewMore}>
                            <div className={styles.detailInfoStickyHeader}>
                                <img onClick={handleBack} src={backBtn} />
                                <div className={styles.rightBtns}>
                                    <img
                                        onClick={() => handleDirections(selectedItem)}
                                        src={directions}
                                    />
                                </div>
                            </div>

                            {selectedItem.customTheme === "gjepc" ? (
                                <div className={styles.customThemePanel}>
                                    <img
                                        className={styles.customThemeLogo}
                                        src={selectedItem.Catalog_CompanyLogo || "/textures/gjepc-logo.png"}
                                        alt="GJEPC"
                                    />
                                    <div className={styles.title}>
                                        {selectedItem.Exhibitor_Name}
                                    </div>
                                    <table>
                                        <tr>
                                            <td><b>Stall No. </b></td>
                                            <td>{selectedItem.Exhibitor_StallNo1 || stallString}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Hall No. </b></td>
                                            <td>{selectedItem.Exhibitor_Hall}</td>
                                        </tr>
                                    </table>
                                </div>
                            ) : (
                                <>
                                    <ImageCarousel data={selectedItem.Catalog_ProductLogo} />
                                    <div className={styles.infoContainer}>
                                        <div className={styles.title}>
                                            {selectedItem.Exhibitor_Name}
                                        </div>
                                        <table>
                                            {selectedItem.Exhibitor_Section && (
                                                <tr>
                                                    <td><b>Section</b></td>
                                                    <td>{`${selectedItem.Exhibitor_Section}`}</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td><b>Stall No. </b></td>
                                                <td>{`${stallString}`}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Hall No. </b></td>
                                                <td>{`${selectedItem.Exhibitor_Hall}`}</td>
                                            </tr>
                                        </table>
                                        <div className={styles.extraInfoCatalog}>
                                            {selectedItem.Catalog_Brief}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>
                {!navigationView &&
                    isMobileDevice &&
                    searchList.length == 0 &&
                    focused && (
                        <div
                            style={{ height: directionMode ? "30vh" : "50vh" }}
                            className={styles.emptyList}
                        ></div>
                    )}
            </form>
            {shareModal && (
                <>
                    <div onClick={handleModal} className={styles.modalOverlay}></div>
                    <div className={styles.shareModal}>
                        <div className={styles.close}>
                            <img src={close} onClick={handleModal} className="btn" />
                        </div>
                        <div className={styles.title}>Share</div>
                        <canvas className={styles.canvas} id="canvas" />
                        <div className={styles.linkWrapper}>
                            <div id={styles.link}></div>
                            <img src={copy} id="copy" className="btn" />
                        </div>
                        <div className={styles.socialHandles}>
                            {socialHandles.map((social,index) => {
                                return (
                                    <img
                                        key={index}
                                        src={social.src}
                                        onClick={handleShare(social.name)}
                                        className="btn"
                                    />
                                );
                            })}
                        </div>
                    </div>
                </>
            )}

            <div className={styles.filtersDiv}>
                <img
                    src="/textures/home.svg"
                    className={styles.btn}
                    style={{ margin: "0vh 1vh" }}
                    onClick={handleHomeBtnClick}
                />
                {!directionMode && searchTabs
                    .filter((item) => item.type == filterType.type)
                    .map((tab) => {
                       
                        if (filterType.type == "home" && scene == "JIO") {
                            if (hiddenFilters.includes(tab.id)) {
                                return null
                            }
                        }
                        if (filterType.type == "hall" && scene == "JIO") {
                            if (hiddenFilters.includes(tab.id)) {
                                return null
                            }
                        }

                        const sceneKey = scene.toUpperCase();
                        const hallKey = filterType.id ? `${sceneKey}:${filterType.id}` : null;
                        const sceneHidden = HIDDEN_TABS_BY_CONTEXT[sceneKey] || [];
                        const hallHidden = hallKey ? (HIDDEN_TABS_BY_CONTEXT[hallKey] || []) : [];
                        if (sceneHidden.includes(tab.id) || hallHidden.includes(tab.id)) {
                            return null;
                        }

                        return (
                            <div
                            key={tab.id}
                                style={tab.id == highlightedTab ? { background: "#000", color: "#fff" } : {}}
                                onClick={() => additionalTabsClick(tab.id)}
                                className={styles.filtersTab}
                            >
                                {tab.name}
                            </div>
                        );
                    })}
            </div>
            {foodMenu && (
                <>
                    <div onClick={() => setFoodMenu("")} className={styles.foodmenuOverlay}></div>
                    <div className={styles.foodMenuWrapper}>
                        <div className={styles.header}>FOOD MENU</div>
                        {CafeList[foodMenu]()}
                    </div>
                </>
            )}
        </div>
    );
};

export default Search;
